import { Controller } from '@hotwired/stimulus'

// The signature a signer draws with a finger or a mouse on the signing page (SignatureRequestsController): each stroke
// ends by writing the drawing as a PNG data URL into the hidden field the form sends (SignatureRequests::SignService).
export default class extends Controller {
  static targets = ['canvas', 'input']

  connect () {
    this.pen = this.canvasTarget.getContext('2d')
    this.drawing = false
    this.resize = this.resize.bind(this)
    this.resize()
    window.addEventListener('resize', this.resize)

    this.start = this.start.bind(this)
    this.move = this.move.bind(this)
    this.end = this.end.bind(this)
    this.canvasTarget.addEventListener('pointerdown', this.start)
    this.canvasTarget.addEventListener('pointermove', this.move)
    this.canvasTarget.addEventListener('pointerup', this.end)
    this.canvasTarget.addEventListener('pointerleave', this.end)
  }

  disconnect () {
    window.removeEventListener('resize', this.resize)
    this.canvasTarget.removeEventListener('pointerdown', this.start)
    this.canvasTarget.removeEventListener('pointermove', this.move)
    this.canvasTarget.removeEventListener('pointerup', this.end)
    this.canvasTarget.removeEventListener('pointerleave', this.end)
  }

  clear () {
    this.pen.clearRect(0, 0, this.canvasTarget.width, this.canvasTarget.height)
    this.inputTarget.value = ''
  }

  // A new width empties the canvas: the trainee draws again. A height-only resize (a phone's address bar showing or
  // hiding on scroll) keeps the drawing.
  resize () {
    const ratio = window.devicePixelRatio || 1
    const { width, height } = this.canvasTarget.getBoundingClientRect()
    if (width === this.width) return

    this.width = width
    this.canvasTarget.width = width * ratio
    this.canvasTarget.height = height * ratio
    this.pen.scale(ratio, ratio)
    this.pen.lineWidth = 2.5
    this.pen.lineCap = 'round'
    this.pen.lineJoin = 'round'
    this.pen.strokeStyle = '#1f2a44'
    this.inputTarget.value = ''
  }

  start (event) {
    event.preventDefault()
    this.drawing = true
    this.canvasTarget.setPointerCapture(event.pointerId)
    const { x, y } = this.position(event)
    this.pen.beginPath()
    this.pen.moveTo(x, y)
  }

  move (event) {
    if (!this.drawing) return

    event.preventDefault()
    const { x, y } = this.position(event)
    this.pen.lineTo(x, y)
    this.pen.stroke()
  }

  end () {
    if (!this.drawing) return

    this.drawing = false
    this.inputTarget.value = this.canvasTarget.toDataURL('image/png')
  }

  position (event) {
    const rect = this.canvasTarget.getBoundingClientRect()
    return { x: event.clientX - rect.left, y: event.clientY - rect.top }
  }
}
